import { motion } from 'framer-motion';
import { lc } from '@/i18n/copy';
import type { Language } from '@/i18n/types';

const copy = {
  en: { streak1: "You've said something that mattered", streak2: 'times.', keepGoing: 'Keep going.', impact: "Your words are making an impact.", dontStop: "Don't stop now." },
  es: { streak1: 'Has dicho algo que importó', streak2: 'veces.', keepGoing: 'Sigue así.', impact: 'Tus palabras están haciendo impacto.', dontStop: 'No pares ahora.' },
  fr: { streak1: 'Vous avez dit quelque chose qui comptait', streak2: 'fois.', keepGoing: 'Continuez.', impact: 'Vos mots ont un impact.', dontStop: "N'arrêtez pas maintenant." },
  pt: { streak1: 'Você disse algo que importou', streak2: 'vezes.', keepGoing: 'Continue assim.', impact: 'Suas palavras estão fazendo impacto.', dontStop: 'Não pare agora.' },
  ar: { streak1: 'لقد قلت شيئاً مهماً', streak2: 'مرات.', keepGoing: 'استمر.', impact: 'كلماتك تصنع فرقاً.', dontStop: 'لا تتوقف الآن.' },
  ja: { streak1: '大切なことを伝えました', streak2: '回。', keepGoing: '続けましょう。', impact: 'あなたの言葉は影響を与えています。', dontStop: '止まらないで。' },
  ko: { streak1: '의미 있는 말을 했습니다', streak2: '번.', keepGoing: '계속하세요.', impact: '당신의 말이 영향을 미치고 있습니다.', dontStop: '멈추지 마세요.' },
  id: { streak1: 'Anda telah mengatakan sesuatu yang berarti', streak2: 'kali.', keepGoing: 'Terus lakukan.', impact: 'Kata-kata Anda berdampak.', dontStop: 'Jangan berhenti sekarang.' },
  hi: { streak1: 'आपने कुछ मायने रखने वाला कहा', streak2: 'बार।', keepGoing: 'जारी रखें।', impact: 'आपके शब्द प्रभाव डाल रहे हैं।', dontStop: 'अब मत रुकिए।' },
};

interface Props {
  totalSaved: number;
  language: Language;
}

export function IdentityStreak({ totalSaved, language }: Props) {
  const c = lc(copy, language);

  // Alternate between two message styles
  const useImpactVersion = totalSaved % 2 === 0 && totalSaved >= 3;

  return (
    <motion.div
      className="mx-4 mb-4 px-4 py-3 rounded-2xl bg-white/[0.03] border border-white/[0.06] lg:mx-6"
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.2 }}
    >
      {useImpactVersion ? (
        <div className="text-center">
          <p className="text-[13px] text-white/85 font-medium">{c.impact}</p>
          <p className="text-[11px] text-white/65 mt-0.5">{c.dontStop}</p>
        </div>
      ) : (
        <div className="text-center">
          <p className="text-[13px] text-white/85">
            {c.streak1} <span className="font-bold text-white">{totalSaved}</span> {c.streak2}
          </p>
          <p className="text-[11px] text-white/65 mt-0.5">{c.keepGoing}</p>
        </div>
      )}
    </motion.div>
  );
}
